// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Privacy_container__BMXw6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: var(--color-mima-light);
}
.Privacy_container_privacy__UGaGN {
  padding-top: 6rem;
  width: 80%;
  padding-bottom: 6rem;
}
.Privacy_container_privacy__list__cW2ul {
  list-style-type: disc;
  padding-left: 5.5rem;
}
@media only screen and (max-width: 31.25em) {
  .Privacy_container_privacy__list__cW2ul {
    padding-left: 3rem;
  }
}
.Privacy_container_privacy__list__cW2ul > li {
  font-size: var(--default-font-size);
  line-height: 2.7rem;
  margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/Privacy.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,yCAAA;AADJ;AAGI;EACI,iBAAA;EACA,UAAA;EACA,oBAAA;AADR;AAGQ;EACI,qBAAA;EACA,oBAAA;AADZ;AAGY;EAJJ;IAKQ,kBAAA;EAAd;AACF;AAEW;EACC,mCAAA;EACA,mBAAA;EACA,mBAAA;AAAZ","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    background-color: var(--color-mima-light);\n\n    &_privacy {\n        padding-top: 6rem;\n        width: 80%;\n        padding-bottom: 6rem;\n\n        &__list {\n            list-style-type: disc;\n            padding-left: 5.5rem;\n\n            @media only screen and (max-width: $bp-500) {\n                padding-left: 3rem;\n            }\n\n           &>li {\n            font-size: var(--default-font-size);\n            line-height: 2.7rem;\n            margin-bottom: 2rem;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Privacy_container__BMXw6`,
	"container_privacy": `Privacy_container_privacy__UGaGN`,
	"container_privacy__list": `Privacy_container_privacy__list__cW2ul`
};
export default ___CSS_LOADER_EXPORT___;
